export default __webpack_public_path__ + "static/media/SD-footer-bottom-strip.0bdcf963.png";